/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Romanian
export default {
  'fabric.mention.unknow.user.error': 'Utilizator necunoscut {userId}',
  'fabric.mention.noAccess.warning': '{name} nu va fi notificat deoarece nu are acces',
  'fabric.mention.noAccess.label': 'Fără acces',
  'fabric.mention.error.defaultHeadline': 'Ceva nu a funcționat corect',
  'fabric.mention.error.defaultAction': 'Încercați din nou după câteva secunde',
  'fabric.mention.error.loginAgain': 'Deconectați-vă și conectați-vă din nou',
  'fabric.mention.error.differentText': 'Introduceți un text diferit',
  'fabric.elements.mentions.team.member.count': '{0, plural, one{1 membru} few{{0} membri} other{{0} de membri}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one{{0} de membri, inclusiv dvs.} few{{0} de membri, inclusiv dvs.} other{{0} de membri, inclusiv dvs.}}',
  'fabric.elements.mentions.team.member.50plus': '50+ membri',
  'fabric.elements.mentions.team.member.50plus.including.you': '50+ membri, inclusiv dvs.',
  'fabric.elements.mentions.team.mention.highlight.title': 'Menționați echipa',
  'fabric.elements.mentions.team.mention.highlight.description': 'Aduceți pe toată lumea pe pagină cu un singur click. Nu este nicio echipă?',
  'fabric.elements.mentions.team.mention.highlight.description.link': 'Începere',
  'fabric.elements.mentions.team.meantion.highlight.close.button.tooltip': 'Ignorare'
};